import React from 'react';
import {
  getTranslation,
} from '../../../../../ui-kitchen/src/providers/TranslationProvider';
import Button from '../../../../../ui-kitchen/src/components/Button';

const ErrorPage = () => {
  let isModal;
  try {
    isModal = window.self !== window.top;
  } catch (e) {
    isModal = false;
  }
  const closeWindow = () => window.close();
  const errorPageText = getTranslation({
    translationKey: 'error_page',
    fallback: 'Sorry, but there seems to have been a problem. Please try reloading the page.',
  });
  const errorPageWindowText = getTranslation({
    translationKey: 'error_page_window',
    fallback: 'Sorry, but there seems to have been a problem.',
  });
  const windowCloseText = getTranslation({
    translationKey: 'window_close',
    fallback: 'Close this window.',
  });
  return (
    <div className="error-page">
      {isModal && <p>{errorPageText}</p>}
      {!isModal && (
        <div>
          <p>
            {errorPageWindowText}
            &nbsp;
            <Button variant="link" as="a" onClick={closeWindow}>
              {windowCloseText}
            </Button>
          </p>
        </div>
      )}
    </div>
  );
};

export default ErrorPage;
